import gql from "graphql-tag";

import {GraphQLResponse} from "@/lib/types/common.ts";
import {ContactGroup, ContactGroupBase} from "@/lib/types/contacts.ts";
import {IntegrationProfile, PushNotificationProfile} from "@/pages/contacts/components/form/types.ts";

export const GQL_CONTACT_GROUPS_LIST_QUERY = gql`
  query ContactGroups($limit: Int!, $offset: Int!, $sort: String, $search: String) {
    integrationProfiles {
      id
      name
    }
    contactGroups(limit: $limit, offset: $offset, sort: $sort, search: $search) {
      total
      items {
        id
        name
        email_list
        phonecall_list
        sms_list
        whatsapp_list
        up_alerts_email_only
        num_services
        num_escalations
        integrations
        push_notification_profiles
        schedule_state
        schedule_entries {
          type
          weekdays
          from_time
          to_time
          once_start_date
          once_end_date
          monthday_from
          monthday_to
        }
      }
    }
  }
`;

export interface ContactGroupItems {
  items: ContactGroup[];
  total: number;
}

export interface ContactGroupsListResult {
  contactGroups: ContactGroupItems;
  integrationProfiles: IntegrationProfile[];
}

export const GQL_CONTACT_GROUPS_BASIC_QUERY = gql`
  query ContactGroups($limit: Int!, $offset: Int!, $sort: String) {
    contactGroups(limit: $limit, offset: $offset, sort: $sort) {
      total
      items {
        id
        name
      }
    }
  }
`;

export interface ContactGroupBaseItems {
  items: ContactGroupBase[];
  total: number;
}

export interface ContactGroupsBaseResult {
  contactGroups: ContactGroupBaseItems;
}

export type UpdateContactGroupResult = GraphQLResponse<ContactGroup>;

export const GQL_UPDATE_CONTACT_GROUP = gql`
  mutation UpdateContact($data: UpdateContactGroupInput!) {
    response: updateContactGroup(data: $data) {
      ... on UpdateContactGroupSuccess {
        status
        data {
          id
          name
          email_list
          phonecall_list
          sms_list
          whatsapp_list
          up_alerts_email_only
          num_services
          num_escalations
          integrations
          push_notification_profiles
          schedule_state
          schedule_entries {
            type
            weekdays
            from_time
            to_time
            once_start_date
            once_end_date
            monthday_from
            monthday_to
          }
        }
      }
      ... on ErrorResponse {
        status
        message
      }
    }
  }
`;

export const GQL_DELETE_CONTACT_GROUP = gql`
  mutation DeleteContactGroup($id: Int!, $force: Boolean) {
    response: deleteContactGroup(id: $id, force: $force) {
      ... on GenericMutationResponseSuccess {
        status
      }
      ... on ErrorResponse {
        status
        message
      }
    }
  }
`;

export const GQL_TEST_CONTACT_GROUP = gql`
  mutation TestContactGroup($id: Int!) {
    response: testContactGroup(id: $id) {
      ... on GenericMutationResponseSuccess {
        status
      }
      ... on ErrorResponse {
        status
        message
      }
    }
  }
`;

export interface IntegrationProfilesResponse {
  integrationProfiles: IntegrationProfile[];
}

export const GQL_INTEGRATION_PROFILES = gql`
  query IntegrationProfiles {
    integrationProfiles {
      id
      name
    }
  }
`;

export interface ContactGroupFormResult {
  pushNotifications: PushNotificationProfile[];
  integrationProfiles: IntegrationProfile[];
}

export const GQL_CONTACT_GROUP_FORM = gql`
  query ContactGroupForm {
    pushNotifications {
      id
      display_name
      is_errored
    }
    integrationProfiles {
      id
      name
    }
  }
`;
